import ReactDOM from 'react-dom';
import {ReactNode} from 'react';

export function Portal(props: { children: ReactNode, owner: HTMLElement }): JSX.Element {
	const {children, owner} = props;
	return ReactDOM.createPortal(children, owner);
}
